import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";

const getYouTubeThumbnail = (url) => {
  if (!url) return null;
  const regExp = /(?:youtube\.com\/.*v=|youtu\.be\/)([^"&?/\s]{11})/;
  const match = url.match(regExp);
  if (!match) return null;
  return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
};

export const AthleteCoachedStrengthWorkoutList = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Incoming coached data
  const { weekId, day, date, items, openIndex, weeks } = location.state || {};

  const formatDate = (d) => {
    if (!d) return "";
    const dateObj = new Date(d);
    return dateObj.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
  };

  console.log(items);

  // No data:
  if (!items || items.length === 0) {
    return (
      <AthleteLayout>
        <AthleteHeader />
        <p className="text-center text-black py-10">No workout data found</p>
      </AthleteLayout>
    );
  }

  /** BACK → Return to coached page with expanded week */
  const handleBackClick = () => {
    navigate("/athlete/coached/strength-workout", {
      state: { openIndex, weeks }, // <-- pass the full weeks
    });
  };

  /** GO TO EXERCISE DETAILS */
  const goToExercise = (exerciseObj) => {
    if (!exerciseObj?.exercise_id?._id) return;

    navigate(
      `/athlete/coached/strength-workout/day/exercise/${exerciseObj.exercise_id._id}`,
      {
        state: {
          weekId,
          day,
          exercise: exerciseObj,
        },
      },
    );
  };

  return (
    <AthleteLayout>
      <div className="h-full flex flex-col bg-white">
        <div className="flex-1 overflow-y-auto">
          <div className="bg-white">
            <AthleteHeader />

            {/* HEADER */}
            <div className="w-full max-w-2xl mx-auto pt-3 px-5">
              <div className="pb-4 border-b border-black/30">
                <div className="bg-[#f5f4f4] rounded-xl p-3 flex items-start gap-5">
                  <span
                    className="text-black cursor-pointer mt-1"
                    onClick={handleBackClick}
                  >
                    <BackArrow />
                  </span>
                  <div className="relative text-start">
                    <p className="text-black text-xl xs:text-2xl font-bold !leading-none capitalize mb-2">
                      workout
                    </p>
                    <div>
                      <p className="text-black text-base xs:text-lg font-medium !leading-tight">
                        Coached Strength Workout
                      </p>

                      {/* <p className="text-lightSmock text-sm font-medium !leading-tight mt-1">
                        {formatDate(day.date)}
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* LIST */}
            <div className="w-full max-w-2xl mx-auto pt-1 px-5">
              {items.map((item, idx) => {
                const isGroup =
                  item.type === "superset" || item.type === "circuit";
                const exercises = isGroup
                  ? item[item.type]?.exercises || []
                  : [];

                const barColor =
                  item.type === "exercise"
                    ? "bg-blue-500"
                    : item.type === "superset"
                      ? "bg-purple-500"
                      : "bg-orange-500";

                /** SINGLE EXERCISE */
                if (!isGroup) {
                  return (
                    <div
                      key={idx}
                      className="flex items-center gap-4 py-4 border-b border-black/30 cursor-pointer"
                      onClick={() => goToExercise(item.exercise)}
                    >
                      <div
                        className={`w-1 h-[60px] rounded-full  bg-darkYellow`}
                      />

                      <div className="size-10 xs:size-14 overflow-hidden bg-gray-200">
                        <img
                          src={getYouTubeThumbnail(
                            item.exercise.exercise_id.video_url,
                          )}
                          className="w-full h-full object-cover"
                        />
                      </div>

                      <p className="text-black font-medium text-base xs:text-xl leading-tight capitalize">
                        {item.exercise.exercise_id.title}
                      </p>
                    </div>
                  );
                }

                /** GROUP: Superset or Circuit */
                return (
                  <div key={idx} className="py-3">
                    {/* Group Header */}
                    <div className="pl-5">
                      <div className="py-2 px-3 bg-smock rounded-xl mb-2">
                        <p className="text-black font-light text-xs capitalize">
                          {item.type === "superset"
                            ? item.superset.title || "Superset"
                            : item.circuit.title || "Circuit"}
                        </p>
                      </div>
                    </div>
                    <div className="flex flex-row gap-4">
                      <div className={`w-1 rounded-full bg-darkYellow`} />

                      <div className="flex-1">
                        {/* List exercises */}
                        {exercises.map((ex, idy) => (
                          <div
                            key={idy}
                            className="flex items-center gap-4 py-4 cursor-pointer border-b border-black/30 "
                            onClick={(e) => {
                              e.stopPropagation();
                              goToExercise(ex);
                            }}
                          >
                            <div className="size-10 xs:size-14 overflow-hidden bg-gray-200">
                              <img
                                src={getYouTubeThumbnail(
                                  ex.exercise_id.video_url,
                                )}
                                className="w-full h-full object-cover"
                              />
                            </div>

                            <p className="text-black font-medium text-base xs:text-xl leading-tight capitalize">
                              {ex.exercise_id.title}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};

const BackArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 19l-7-7 7-7"
    />
  </svg>
);
